// constants
import { PRODUCT_WIDTH, PRODUCT_HEIGHT } from './constants';

// using ratio to get the aspect ratio
export const getProductHeight = (productWidth: number) => {
  if (productWidth !== 0) {
    return (productWidth * PRODUCT_HEIGHT) / PRODUCT_WIDTH;
  }
  return null;
};
